import {
  Activity,
  getActivityComment,
  postActivityComment,
} from "@portal/api/comment";
import { notify } from "@portal/BaseComponents/Notifications";
import { CommentDTO } from "@portal/types/entities/comment";
import { useMutation, useQuery } from "@tanstack/react-query";

interface CommentQueyProps {
  activity: Activity;
  params?: string;
}
function useAddComment(props: CommentQueyProps) {
  return useMutation({
    mutationKey: [`${props.activity}-comment-add`],
    mutationFn: (value: CommentDTO) =>
      postActivityComment(props.activity, value, props.params),
    onSuccess() {
      notify.success("Comment Added Successfully");
    },
    onError() {
      notify.error("Failed to Add Comment Please try again later.");
    },
  });
}

function useGetCommentsQuery(props: CommentQueyProps) {
  return useQuery({
    queryKey: [`${props.activity}-comments-${props.params}`, props.params],
    queryFn: () => getActivityComment(props.activity, props.params),
    retry: false,
    enabled: Boolean(props.params?.length),
  });
}

export { useAddComment, useGetCommentsQuery };
